import { apiAxios } from '@/api'
import { fetchWrapper } from '@/reducers/fetch'
import type { SignupPlan } from './signupPlans.types'

export const FETCH_SIGNUP_PLANS_KEY = 'FETCH_SIGNUP_PLANS_KEY'

export const fetchSignupPlans = () =>
  fetchWrapper({
    fetchKey: FETCH_SIGNUP_PLANS_KEY,
    fetchFunction: async () => {
      const { data } = await apiAxios.get<{ plans: SignupPlan[] }>(
        '/finances/api/v2/signup_plans'
      )
      return data.plans
    },
  })
